var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronBlackBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "9px",
    viewBox: "0 0 6 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overlay---Muuda-Nime",
    transform: "translate(-124.000000, -240.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(32.000000, 222.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(93.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    transform: "translate(2.000000, 8.500000) rotate(90.000000) translate(-2.000000, -8.500000) ",
    points: "-1 7 2 10 5 7"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronBlackBack);
export default __webpack_public_path__ + "static/media/Icon_Chevron_Black-Back.6a9673f3626589a98e563eb0497a455d.svg";
export { ForwardRef as ReactComponent };